:host {
  display: block;
  max-width: 100%;
}

.container {
  display: flex;
}

.basic-btn {
  margin-top: calc(var(--spacer) - 2px);
  height: 16px;
}

gz-search-query {
  --monaco-scrollable-element-width: -webkit-fill-available;
  --monaco-padding-right: 55px;
  --font-family: 'IBMPlex', serif;
  --monaco-monospace-font: 'IBMPlex', serif;
  --placeholder-postion-left: 63px;
}

gz-info-box {
  padding: var(--spacer) 0;
}

//mozilla
@supports (-moz-appearance: none) {
  gz-search-query {
    --monaco-scrollable-element-width: -moz-available;
  }
}

//safari
@supports (background: -webkit-named-image(i)) {
  gz-search-query {
    --monaco-scrollable-element-width: calc(100% - 51px);
  }
}
